module.exports = "/images/pin_color.png?7658c02e941dfe5b3a25b310da947531";